// extracted by mini-css-extract-plugin
module.exports = {"list":"Texts_list__D_wfR","text":"Texts_text__H8bbW","table":"Texts_table__QJ8es"};